<template>
  <div>
    <HeroSection :product="cheapestProduct" :img="images.hero" />
    <VisaFormSection :products ref="formSection" />
    <TrustingCompaniesSection />
    <StepsSection :example="images.evisa" />
    <TrustSection :product="cheapestProduct" />
    <Testimonials v-if="testimonials.length > 0" :testimonials />
    <MoreReviewsStrip v-if="$branch.reviews.public" :links="$branch.reviews.links" />
    <CountryKeyPointsSection :product="cheapestProduct" :img="images.features" />
    <FaqSection :faqs />
    <FormCtaSection :price="cheapestProduct.price" :img="images.cta" />

    <ChatWidget />
  </div>
</template>

<script setup lang="ts">
import type { CountryKey } from "~/types";
import { countryKeyInjectionKey } from '~/assets/injection-keys';
import { findCheapestProduct } from "~/helpers/product";
import { getCurrentYear } from "~/helpers/date";
import { getCountryImages } from "~/helpers/image-maps";

const props = defineProps<{
  country: CountryKey;
}>();

const products = await useProducts(props.country);
const images = getCountryImages(props.country);
const cheapestProduct = findCheapestProduct(products);
const { faqs } = useFaq(props.country, products, { hasGlobals: true });
const currentYear = getCurrentYear();
const { testimonials } = useTestimonials(props.country);
const { tt } = useLocalization();
const { displayPrice } = useFormat();

usePageHead({
  title: tt(`${props.country}_page.title`, { currentYear }),
  description: tt(`${props.country}_page.meta_desc`, { currentYear, price: displayPrice(cheapestProduct.price) }),
  alternateBranches: 'all'
});

const formSectionRef = useTemplateRef('formSection');

provide(countryKeyInjectionKey, props.country);

useSchemaOrg('products', { products });

useEmitter().ctaClickBus.on(goToForm);
function goToForm() {
  formSectionRef.value?.$el.scrollIntoView();
}
</script>